import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-1078271065__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Person", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-1078271065__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("circle", {
      cx: "95.43",
      cy: "48",
      r: "26",
      style: {"fill":"none"}
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M95.43 14c-18.75 0-34 15.25-34 34s15.25 34 34 34 34-15.25 34-34-15.25-34-34-34m0 60c-14.34 0-26-11.66-26-26s11.66-26 26-26 26 11.66 26 26-11.66 26-26 26M171.86 172.94l-17.35-63.03C151.29 98.19 140.61 90 128.54 90H63.49c-12.06 0-22.74 8.18-25.97 19.89l-17.38 63.02 7.71 2.13 17.38-63.02C47.5 103.77 55.01 98 63.48 98h65.05c8.48 0 15.99 5.77 18.26 14.03l17.35 63.03 7.71-2.12Z",
      class: "i-1078271065__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "person"}) } }